<div *ngIf="toggleElements" [formGroup]="group" [class.form-group]="!group.disabled" class="row display-flex">

  <!-- label if isEdit  -->
  <label *ngIf="(getControlName.enabled || config.presentation === 'filter' || config.presentation === 'detail')
                  || (config.presentation === 'edit' && config.options.labelShowInDetail)"
         for="{{config.label}}" class="control-label" style="white-space: nowrap;"
         [class.col-sm-0]="config.options.longInput"
         [class.col-sm-3]="!config.options.longInput">
    {{config.label | translate:locale.language}}
  </label>

  <div class="parent-container"
       [class.col-sm-12]="config.options.longInput"
       [class.col-sm-9]="!config.options.longInput"
       formGroupName="{{config.controlName[0]}}">

    <!--  normal form  -->
    <div *ngIf="getControlName.enabled && config.presentation === 'edit'" style="width: 100%;">
      <select style="zoom:75%"
              formControlName="{{config.controlName[1]}}"
              ctrl-error
              class="form-control optgroup"
              id="{{config.label}}"
              [required]="getControlName?.errors !== null && getControlName?.errors['required']">
        <option  *ngIf="config?.options?.allowOptionEmpty === undefined" value=""></option>
        <option class="optgroup"
                *ngFor="let option of datas"
                [disabled]="option.name === separator"
                [ngValue]="option[config.options.value]">
        <span *ngIf="config?.options?.hideOption !== option[config.options.value]"> {{ option[config.options.vue] | translate:locale.language }}</span>
        </option>
      </select>

      <!-- errors form -->
      <div>
        <span *ngIf="showWarning" class="icon-warning">
          <i tooltip="{{ 'WARNING_SELECT_DATA_CHANGE' | translate:locale.language}}"  class="fas fa-exclamation-triangle"></i>
        </span>
        <span *ngIf="group.get([config.controlName[0], config.controlName[1]]).invalid &&
                    !group.get([config.controlName[0], config.controlName[1]]).value" class="icon-mandatory">*</span>
      </div>
    </div>

    <!-- filter form -->
    <div *ngIf="config.presentation === 'filter'" style="width: 100%;">
      <select class="form-control"  formControlName="{{config.controlName[1]}}" id="{{config.label}}">
        <option value=""></option>
        <option *ngFor="let option of datas" [value]="option[config.options.value]">
          {{ option.name | translate:locale.language }}
        </option>
      </select>
    </div>

    <!-- presentation form  -->
    <div *ngIf="getControlName.disabled || config.presentation === 'detail'" style="width:100%;font-weight:bold;">
      <span  *ngFor="let option of datas" >
        <span *ngIf="option[config.options.value]==group.get(config?.controlName)?.value" >{{ option[config.options.vue] | translate:locale.language }}</span></span>
    </div>


  </div>
</div>

<div *ngIf="false">
  <pre>datas{{ datas | json}}</pre>
  <pre>errors: {{getControlName?.errors}}</pre>
  <pre>presentation:{{config.presentation}}</pre>
<!--  <pre>hideIfDisabled:{{config.options.hideIfDisabled}}</pre>-->
  <pre>enabled:{{getControlName.enabled}}</pre>
  <pre>option value:{{config.options.value}}</pre>
  <pre>option value:{{group.get(config.controlName).value}}</pre>
</div>

